module.exports = __webpack_public_path__ + "media/question1_en.32045d98.wav";